var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#141414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85634 14.8549C6.54205 14.8549 6.28491 14.5978 6.28491 14.2835V7.56348C6.28491 7.26063 6.16491 6.9692 5.94777 6.75777L1.30777 2.11777C1.08491 1.89491 1.08491 1.53491 1.30777 1.31205C1.41634 1.20348 1.5592 1.14062 1.71348 1.14062H14.2849C14.5992 1.14062 14.8563 1.39777 14.8563 1.71205C14.8563 1.86634 14.7935 2.0092 14.6906 2.11777L10.0506 6.75777C9.83348 6.9692 9.71348 7.26063 9.71348 7.56348V11.9978C9.71348 12.1521 9.65062 12.2949 9.54777 12.4035L7.26205 14.6892C7.15348 14.7921 7.01062 14.8549 6.85634 14.8549Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.bfbebd541d2fd892d4ab76c9c3084fca.svg";
export { ForwardRef as ReactComponent };